
import { Input } from "element-ui"
import { bindYuu, unBindYuu, queryBindYuu } from "@/api/auth"
import { showMessage } from "@/components/cart/js/common.js"
import Storage from "@/utils/storage"
import { getLoginStatus } from "@/utils/utils"
export default {
  name: "LinkYuu",
  components: {
    [Input.name]: Input
  },
  props: {
    linkYuuInfo: {
      type: Object,
      default: () => ({
        status: "hidden", // hidden/linking/unlinking
        isLink: false,
        yuuId: ""
      })
    }
  },
  data() {
    return {
      yuuId: this.linkYuuInfo.yuuId
    }
  },
  watch: {
    "linkYuuInfo.yuuId": {
      handler(val) {
        this.yuuId = val
      }
    }
  },
  mounted() {
    const { isOnline } = getLoginStatus()
    if (isOnline) {
      this.init()
    }
  },
  methods: {
    async init() {
      try {
        const { data } = await queryBindYuu({ param: JSON.stringify(this.getParams()) })
        // 已绑定yuuId
        if (data && data.thirdBindId) {
          this.$emit("changeLinkYuuInfo", { status: "hidden", isLink: true, yuuId: data.thirdBindId || "" })
        }
      } catch (error) {}
    },
    getParams() {
      const { custId } = Storage.get("accountInfo", { useBase64: true }) || {}
      return {
        custId: custId || "",
        loginChannel: 3
      }
    },
    toggleShow() {
      this.$emit("changeLinkYuuInfo", {
        ...this.linkYuuInfo,
        status: this.linkYuuInfo.status === "hidden" ? "linking" : "hidden"
      })
    },
    async handleLink() {
      try {
        // 限制8位数字
        if (this.yuuId.length !== 8 || !/^\d{8}$/.test(this.yuuId)) {
          showMessage(this.$t("linkYuu.textWith11Digits"))
          return
        }

        const params = {
          yuuId: this.yuuId, // 80197890
          ...this.getParams()
        }
        await bindYuu({ param: JSON.stringify(params) })
        this.$emit("changeLinkYuuInfo", { status: "hidden", isLink: true, yuuId: this.yuuId })
        // cart和header都有link yuu，绑定或解绑需要两边需要同步
        this.$bus.$emit("changeLinkYuuInfo", { status: "hidden", isLink: true, yuuId: this.yuuId })
      } catch (error) {}
    },
    openUnlinkContent() {
      this.$emit("changeLinkYuuInfo", { ...this.linkYuuInfo, status: "unlinking" })
    },
    handleCancelUnlink() {
      this.$emit("changeLinkYuuInfo", { ...this.linkYuuInfo, status: "hidden" })
    },
    async handleUnlink() {
      try {
        const params = {
          yuuId: this.yuuId,
          ...this.getParams()
        }
        await unBindYuu({ param: JSON.stringify(params) })
        this.$emit("changeLinkYuuInfo", { status: "hidden", isLink: false, yuuId: "" })
        // cart和header都有link yuu，绑定或解绑需要两边需要同步
        this.$bus.$emit("changeLinkYuuInfo", { status: "hidden", isLink: false, yuuId: "" })
      } catch (error) {}
    }
  }
}
